// Common corporate suffixes that add noise but no identity. Matched
// case-insensitively against whole tokens in the *end* of the string.
const SUFFIXES = new Set([
  "inc",
  "llc",
  "co",
  "ltd",
  "plc",
  "corp",
  "corporation",
  "incorporated",
  "company",
  "limited",
  "sa",
  "sas",
  "gmbh",
  "ag",
]);

/**
 * Normalize a vendor string for matching and hashing:
 *   - lowercase
 *   - trim
 *   - collapse internal whitespace
 *   - strip punctuation (keep alphanumerics and spaces)
 *   - drop trailing corporate suffix tokens (e.g. "Stripe Inc" → "stripe")
 */
export function normalizeVendor(raw: string): string {
  if (!raw) return "";
  let s = raw.toLowerCase();
  // Strip punctuation — any char that isn't a letter, digit, or space.
  s = s.replace(/[^\p{L}\p{N}\s]/gu, " ");
  s = s.replace(/\s+/g, " ").trim();
  if (!s) return "";

  // Drop trailing suffix tokens. Keep stripping while the last word is a
  // recognised suffix — this handles "Acme Corp Ltd" → "acme".
  const tokens = s.split(" ");
  while (tokens.length > 1 && SUFFIXES.has(tokens[tokens.length - 1]!)) {
    tokens.pop();
  }
  return tokens.join(" ");
}
